// Common Actions
export const FETCH_START = "FETCH_START";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_ERROR = "FETCH_ERROR";
export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";
export const TOGGLE_CART = "TOGGLE_CART";
export const RESET_CART_STEP = "RESET_CART_STEP";
export const SET_CART_STEP = "SET_CART_STEP";

// Auth Actions
export const SIGN_IN = "SIGN_IN";
export const SET_LOGGIN_LOADING = "SET_LOGGIN_LOADING";
export const SIGN_UP = "SIGN_UP";
export const GET_USER_INFORMATION = "GET_USER_INFORMATION";
export const IS_GETTING_USER_INFO = "IS_GETTING_USER_INFO";
export const GET_USER_INFORMATION_FAILURE = "GET_USER_INFORMATION_FAILURE";
export const TOKEN_STORAGE_KEY = "TOKEN_STORAGE_KEY";
export const CONTINUE_AS_GUEST = "CONTINUE_AS_GUEST";

// Shopping Cart Actions
export const GET_CART = "GET_CART";
export const REMOVE_LINE_ITEM = "REMOVE_LINE_ITEM";
export const CLEAR_CART = "CLEAR_CART";

// Checkout Actions
export const SET_CHECKOUT_ID = "SET_CHECKOUT_ID";
export const SET_CHECKOUT = "SET_CHECKOUT";
export const CREATE_CHECKOUT = "CREATE_CHECKOUT";
export const UPDATE_CHECKOUT = "UPDATE_CHECKOUT";
export const SET_CHECKOUT_SHIPPING_ADDRESS_ERRORS = "SET_CHECKOUT_SHIPPING_ADDRESS_ERRORS";
export const CHECKOUT_EMAIL_UPDATE_SUCCESS = "CHECKOUT_EMAIL_UPDATE_SUCCESS";
export const CHECKOUT_EMAIL_UPDATE_ERROR = "CHECKOUT_EMAIL_UPDATE_ERROR";

// Shopify Actions
export const INIT_CLIENT = "INIT_CLIENT";
export const INIT_CLIENT_SUCCESS = "INIT_CLIENT_SUCCESS";

// User Actions
export const IS_UPDATING_BILLING_INFORMATION = "IS_UPDATING_BILLING_INFORMATION";
export const UPDATING_BILLING_INFORMATION_SUCCESS = "UPDATING_BILLING_INFORMATION_SUCCESS";
export const UPDATING_BILLING_INFORMATION_ERROR = "UPDATING_BILLING_INFORMATION_ERROR";
export const IS_UPDATING_SHIPPING_INFORMATION = "IS_UPDATING_SHIPPING_INFORMATION";
export const UPDATING_SHIPPING_INFORMATION_SUCCESS = "UPDATING_SHIPPING_INFORMATION_SUCCESS";
export const UPDATING_SHIPPING_INFORMATION_ERROR = "UPDATING_SHIPPING_INFORMATION_ERROR";

export const IS_UPDATING_CONTACT_EMAIL = "IS_UPDATING_CONTACT_EMAIL";
export const UPDATING_CONTACT_EMAIL_SUCCESS = "UPDATING_CONTACT_EMAIL_SUCCESS";
export const UPDATING_CONTACT_EMAIL_ERROR = "UPDATING_CONTACT_EMAIL_ERROR";
export const SET_SHIPPING_METHOD = "SET_SHIPPING_METHOD";
export const SET_SHIPPING_ADDRESS_SAME_AS_BILLING = "SET_SHIPPING_ADDRESS_SAME_AS_BILLING";
export const GET_SHIPPING_RATES = "GET_SHIPPING_RATES";
export const IS_GETTING_SHIPPING_RATES = "IS_GETTING_SHIPPING_RATES";
export const GETTING_SHIPPING_RATES_SUCCESS = "GETTING_SHIPPING_RATES_SUCCESS";
export const GETTING_SHIPPING_RATES_FAILURE = "GETTING_SHIPPING_RATES_FAILURE";

export const UPDATE_SHIPPING_INFO_START = "IS_UPDATING_SHIPPING_INFORMATION";
export const UPDATE_SHIPPING_INFO_SUCCESS = "UPDATING_SHIPPING_INFORMATION_SUCCESS";
export const UPDATE_SHIPPING_INFO_ERROR = "UPDATING_SHIPPING_INFORMATION_ERROR";
